import _ from 'lodash'

const exists = (state, serverId, userId) =>
    state[serverId] != null && state[serverId].indexOf(userId) > -1

const addId = (state, serverId, userId) => ({
    ...state,
    [serverId]: [...(state[serverId] || []), userId],
})

const removeId = (state, serverId, userId) => ({
    ...state,
    [serverId]: _.without(state[serverId], userId),
})

export const add = (state, serverId, userId) => {
    if (exists(state, serverId, userId)) return state
    return addId(state, serverId, userId)
}

export const remove = (state, serverId, userId) => {
    if (!exists(state, serverId, userId)) return state
    return removeId(state, serverId, userId)
}

export const toggle = (state, serverId, userId) => {
    if (exists(state, serverId, userId)) return removeId(state, serverId, userId)
    return addId(state, serverId, userId)
}



// WEBPACK FOOTER //
// ./src/features/Users/data/helpers.js